module.exports = __webpack_public_path__ + "img/bbc.744c7c3a.svg";